import {
  SENS_VENTE,
} from '@/configuration/devisConf';

export default function genererCritereRecherche() {
  return {
    client: '',
    code: '',
    codePM: '',
    codesDossier: [],
    etatsDevisCommandeFacture: [],
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    dateFacture: {
      dateDebut: null,
      dateFin: null,
    },
    agencesId: [],
    commercialId: null,
    assistantId: null,
    referenceIds: [],
    ids: [],
    groupeIds: [],
    enseigneIds: [],
    produit: '',
    auto: '',
    sens: SENS_VENTE,
    libelle: '',
    typesProduits: [],
    fournisseursId: [],
    tiersId: [],
    interne: false,
    produitsIds: [],
    produitRegroupementIds: [],
    secteurIds: [],
    typesProduitRegroupement: [],
  };
}
